// extracted by mini-css-extract-plugin
module.exports = {"clickedClassName":"ClickSessionMemorizer_clickedClassName__W0geL"};